import React from "react";

export interface MatrimonyProfilesSvgIconProps {
  size?: number;
}

const MatrimonyProfilesSvgIcon: React.FC<MatrimonyProfilesSvgIconProps> = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    color="currentColor"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Matrimony Profiles"
    role="img"
  >
    {/* Two people / couple icon */}
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

export default MatrimonyProfilesSvgIcon;
